exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-btn[data-v-7631c38e]{background-color:var(--v-helpColor-base);color:var(--v-helpTextColor-base);display:flex;justify-content:center;align-items:center;min-width:24px;min-height:24px;border-radius:100%;padding-top:2px;font-weight:700}.help-btn[data-v-7631c38e]:hover{background-color:var(--v-activeHelpColor-base);color:var(--v-activeHelpTextColor-base)}", ""]);

// exports
